import { CalendarCheck, ClipboardList, Camera, Zap, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const perks = [
  { icon: CalendarCheck, text: "Schedule cleanings tied to guest check-outs" },
  { icon: ClipboardList, text: "Custom checklists for every property" },
  { icon: Camera, text: "Photo verification after every turnover" },
  { icon: Zap, text: "Fast, hassle-free payment on completion" },
];

export default function Turno() {
  return (
    <section id="hosts" className="px-6 md:px-12 py-10 md:py-16" data-testid="turno-section">
      <div className="max-w-[1440px] mx-auto bg-pine rounded-[2.5rem] px-8 md:px-16 py-20 md:py-28 relative overflow-hidden">
        <div
          aria-hidden="true"
          className="absolute -bottom-48 -left-48 w-[480px] h-[480px] rounded-full bg-foam/10 blur-3xl pointer-events-none"
        />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14 items-center relative z-10">
          <div className="md:col-span-7">
            <Reveal>
              <p className="text-[11px] md:text-xs uppercase tracking-[0.28em] text-foam font-medium">
                For Airbnb & STR hosts
              </p>
              <h2 className="mt-5 font-display font-light tracking-tighter leading-[1.02] text-4xl md:text-6xl text-white">
                Hosts can also book us{" "}
                <span className="font-editorial italic font-semibold text-foam">on Turno.</span>
              </h2>
              <p className="mt-7 text-base md:text-lg font-light leading-relaxed text-white/65 max-w-xl">
                We bid on turnover projects through Turno — the platform built for short-term rental
                hosts and cleaners. Accept our bid and scheduling, checklists, photo reports and
                payment all happen in one place.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <a
                href="https://www.turno.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Find Sparkling Ambitions on the Turno marketplace"
                className="group mt-10 inline-flex items-center gap-4 rounded-full bg-foam text-pine pl-7 pr-3 py-2.5 font-display font-medium tracking-wide hover:bg-white transition-colors duration-300"
                data-testid="turno-link-button"
              >
                Find us on Turno
                <span className="w-9 h-9 rounded-full bg-pine text-foam flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
                  <ArrowUpRight size={15} strokeWidth={2} />
                </span>
              </a>
            </Reveal>
          </div>
          <div className="md:col-span-5">
            <ul className="space-y-5">
              {perks.map((p, i) => (
                <Reveal key={p.text} delay={0.1 + i * 0.08}>
                  <li
                    className="flex items-center gap-4 bg-white/[0.06] border border-white/10 rounded-2xl px-6 py-5 backdrop-blur-sm"
                    data-testid={`turno-perk-${i}`}
                  >
                    <span className="w-10 h-10 shrink-0 rounded-full bg-foam/15 text-foam flex items-center justify-center">
                      <p.icon size={17} strokeWidth={1.75} />
                    </span>
                    <span className="text-sm md:text-base font-light text-white/85">{p.text}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
